// extracted by mini-css-extract-plugin
module.exports = {"quotaCard":"StorageUsageModal_quotaCard_2jjuh"};